const routeTitles = {
    '/': 'Inici',
    '/404': 'Pàgina no trobada',
    '/agendaProducte': 'Disponibilitat del producte',
    '/agendaProducte/form': 'Nova disponibilitat del producte',
    '/agendaProducte/form/:id': 'Modificar disponibilitat del producte',
    '/article': 'Articles',
    '/article/form': 'Nou article',
    '/article/form/:id': 'Modificar article',
    '/articleCategoria': 'Categories d\'articles',
    '/articleExistencia': 'Existències d\'articles',
    '/centreCost': 'Centre de cost',
    '/centreCost/form': 'Nou centre de cost',
    '/centreCost/form/:id': 'Modificar centre de cost',
    '/client': 'Clients',
    '/client/form': 'Nou client',
    '/client/form/:id': 'Modificar client',
    '/consumTripulacio': 'Consum tripulació',
    '/consumTripulacio/form': 'Nou consum',
    '/consumTripulacio/form/:id': 'Modificar consum',
    '/controlFotografia': 'Control de fotografia',
    '/controlFotografia/form': 'Nou control de fotografia',
    '/controlFotografia/form/:id': 'Modificar control de fotografia',
    '/embarcacio': 'Embarcacions',
    '/embarcacio/form': 'Nova embarcació',
    '/embarcacio/form/:id': 'Modificar embarcació',
    '/everet': 'Everet',
    '/versio': 'Versió',
    '/informeEmbarcacio': 'Informe de tripulació per embarcació',
    '/informeTripulacio': 'Informe de tripulació',
    '/informeZonaVenedor': 'Informe zona venedor',
    '/informeZonaVenedor/form': 'Nou informe zona',
    '/informeZonaVenedor/form/:id': 'Modificar informe zona',
    '/operacio': 'Operacions',
    '/operacio/form': 'Nova operació',
    '/operacio/form/:id': 'Modificar operació',
    '/operacioLinia': "Línies d'operació",
    '/operacioLiniaArticle': 'Articles de les línies',
    '/parametre': 'Paràmetres',
    '/producte': 'Productes',
    '/producte/form': 'Nou producte',
    '/producte/form/:id': 'Modificar producte',
    '/proveidor': 'Proveïdors',
    '/proveidor/form': 'Nou proveïdor',
    '/proveidor/form/:id': 'Modificar proveïdor',
    '/recurs': 'Recursos',
    '/recurs/form': 'Nou recurs',
    '/recurs/form/:id': 'Modificar recurs',
    '/reserva': 'Reserves',
    '/reserva/form': 'Nova reserva',
    '/reserva/form/:id': 'Modificar reserva',
    '/ruta': 'Rutes planificades',
    '/ruta/form': 'Nova ruta planificada',
    '/ruta/form/:id': 'Modificar ruta planificada',
    '/rutaPunt': 'Punts de ruta',
    '/rutaTripulant': 'Ruta - Tripulant',
    '/serie': 'Sèries',
    '/talonari': 'Talonaris',
    '/talonari/form': 'Crear talonari',
    '/talonari/form/:id': 'Modificar talonari',
    '/talonariBono': 'Bonos de talonari',
    '/talonariBono/form': 'Crear bo de talonari',
    '/talonariBono/form/:id': 'Modificar bo de talonari',
    '/terminal': 'Terminal',
    '/tripulant': 'Tripulants',
    '/user': 'Usuaris',
    '/user/form': 'Nou usuari',
    '/user/form/:id': 'Modificar usuari',
    '/usRecurs': 'Ús de recursos',
    '/zona': 'Zones',
    '/zona/form': 'Nova zona',
    '/zona/form/:id': 'Modificar zona',
    '/zonaUser': 'Zones per usuari',
    '/zonaUser/form': 'Nova zona usuari',
    '/zonaUser/form/:id': 'Modificar zona usuari',
};


export default routeTitles;